import React from 'react';
import { Redirect, Route } from "react-router-dom";
import { ProtectedRouteProps } from "./ProtectedRoute";
import { APIFormDef } from "../../../model/User";
import EditDynamicItemForm from '../../../pages/item/EditDynamicItemForm';

export interface ProtectedEditDynamicFormRouteProps extends Omit<ProtectedRouteProps, "component"> {
    formDefinition: APIFormDef;
    formType: "container" | "file" | "tape";
}

export default function ProtectedEditDynamicFormRoute(props: ProtectedEditDynamicFormRouteProps): JSX.Element {
    const { hasPermission, formDefinition, formType, ...rest } = props;
    return (
        <Route {...rest} render={(props) => {
            return hasPermission
                ? <EditDynamicItemForm formDefinition={formDefinition} formType={formType} {...props} />
                : <Redirect to='/login' />
        }} />
    )
}
